/**
 * array data => .csv file
 * @param {Array} data 
 * @param {[string | {key,title}]} _headers: 
 * @param {string} filename 
 * @param {number} chunkSize 
 * @param {function} uploadProcess 
 * @returns 
 */
function downloadLargeCSVInChunks(data = [], headers = Object.keys(data[0] || {}), filename = 'data.csv', chunkSize = 1000, uploadProcess) {
  if (data.length === 0) return;
  let csvContent = headers.map(header => header.title || header).join(',') + '\n';
  const keys = headers.map(header => header.key || header);
  let currentIndex = 0;

  function processChunk() {
    const startTime = performance.now();
    let chunkData = '';
    let isFirstChunk = true;

    while (currentIndex < data.length &&
      (currentIndex % chunkSize !== 0 || isFirstChunk)
      && performance.now() - startTime < 16) {
      const row = data[currentIndex];
      const values = keys.map(header => {
        const escaped = ('' + row[header]).replace(/"/g, '""');
        return escaped;
      });
      chunkData += values.join(',') + '\n';
      currentIndex++;
      isFirstChunk = false;
    }

    csvContent += chunkData;

    const progress = Math.min(100, (currentIndex / data.length * 100));
    uploadProcess(progress);

    if (currentIndex < data.length) {
      requestAnimationFrame(processChunk);
    } else {
      finalizeDownload();
      uploadProcess(0);
    }
  }

  function finalizeDownload() {
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();

    setTimeout(() => {
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }, 100);
  }

  requestAnimationFrame(processChunk);
}

/**
 * .csv file => array data
 * @param {string} csvText 
 * @param {{title: key}} _headers: 
 * @param {number} chunkSize 
 * @param {function} uploadProcess 
 * @param {function} callback 
 * @returns 
 */
function parseLargeCSVInChunks(csvText, headerKeyObj = {}, chunkSize = 1000, uploadProcess, callback) {
  const lines = csvText.split(/\r?\n/).filter(line => line.trim() !== '');
  if (lines.length === 0) return callback([]);

  const headers = lines[0].split(',');
  const result = [];
  let currentIndex = 1;

  function processChunk() {
    const startTime = performance.now();
    let isFirstChunk = true;
    while (currentIndex < lines.length &&
      (currentIndex % chunkSize !== 0 || isFirstChunk)
      && performance.now() - startTime < 16) {
      const line = lines[currentIndex];
      const values = line.split(',');
      const obj = {};

      headers.forEach((header, i) => {
        const key = headerKeyObj[header.trim()] || header.trim();
        obj[key] = values[i] ? values[i].trim() : '';
      });

      result.push(obj);
      currentIndex++;
    }

    const progress = Math.min(100, (currentIndex / lines.length * 100));
    uploadProcess(progress);

    if (currentIndex < lines.length) {
      requestAnimationFrame(processChunk);
    } else {
      callback(result);
      uploadProcess(0);
    }
  }

  requestAnimationFrame(processChunk);
}

export {
  downloadLargeCSVInChunks,
  parseLargeCSVInChunks
};
